// https://www.dbos.dev/about

import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaStartBuildingForFree, FooterLinksFollowOurGithub } from '@components/layout/FooterCtas';

export function AboutPage() {
  return (
    <SiteLayout
      banner={true}
      footerCta={
        <>
          <FooterCtaStartBuildingForFree />
          <FooterLinksFollowOurGithub />
        </>
      }
    >
      <section className="hero-title">
        <h1 className="text-heading-h1">Durable AI, built effortlessly</h1>
        <p className="text-body text-alignment-left">
          At DBOS, we’re radically rethinking the way AI workflows and software backends are built and made fault
          tolerant.
        </p>
      </section>
      <section className="card-story">
        <div className="card-story-left">
          <h2 className="text-heading-h2">Our story</h2>
          <p className="text-body text-alignment-left">
            Co-founded by Postgres creator—Mike Stonebraker, and a joint team of MIT and Stanford computer scientists,
            DBOS is on a mission to radically simplify the way cloud and AI applications are built, deployed, and
            secured.
            <br />
            <br />
            Let’s shape the future of AI-native technology.
          </p>
        </div>
        <div className="card-story-right">
          <div className="story-highlight">
            <div className="w-embed">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                {'\n'}
                <g clipPath="url(#clip0_285_10884)">
                  {'\n'}
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 1.3335C17 0.781211 16.5523 0.333496 16 0.333496C15.4477 0.333496 15 0.781211 15 1.3335V5.66675H12.6667C11.1638 5.66675 9.72243 6.26377 8.65973 7.32648C7.59702 8.38918 7 9.83052 7 11.3334C7 12.8363 7.59702 14.2776 8.65973 15.3404C9.72243 16.4031 11.1638 17.0001 12.6667 17.0001H15V24.3334H8C7.44772 24.3334 7 24.7811 7 25.3334C7 25.8857 7.44772 26.3334 8 26.3334H15V30.6668C15 31.2191 15.4477 31.6668 16 31.6668C16.5523 31.6668 17 31.2191 17 30.6668V26.3334H19.3333C20.8362 26.3334 22.2776 25.7364 23.3403 24.6737C24.403 23.611 25 22.1696 25 20.6667C25 19.1639 24.403 17.7225 23.3403 16.6598C22.2776 15.5971 20.8362 15.0001 19.3333 15.0001H17V7.66675H22.6667C23.219 7.66675 23.6667 7.21903 23.6667 6.66675C23.6667 6.11446 23.219 5.66675 22.6667 5.66675H17V1.3335ZM15 7.66675H12.6667C11.6942 7.66675 10.7616 8.05306 10.0739 8.74069C9.38631 9.42832 9 10.361 9 11.3334C9 12.3059 9.38631 13.2385 10.0739 13.9261C10.7616 14.6138 11.6942 15.0001 12.6667 15.0001H15V7.66675ZM17 17.0001V24.3334H19.3333C20.3058 24.3334 21.2384 23.9471 21.9261 23.2595C22.6137 22.5718 23 21.6392 23 20.6667C23 19.6943 22.6137 18.7617 21.9261 18.074C21.2384 17.3864 20.3058 17.0001 19.3333 17.0001H17Z"
                    fill="url(#paint0_linear_285_10884)"
                  />
                  {'\n'}
                </g>
                {'\n'}
                <defs>
                  {'\n'}
                  <linearGradient
                    id="paint0_linear_285_10884"
                    x1="8.5"
                    y1="20.5001"
                    x2="26"
                    y2="18.5001"
                    gradientUnits="userSpaceOnUse"
                  >
                    {'\n'}
                    <stop offset="0.03" stopColor="#C8F62E" />
                    {'\n'}
                    <stop offset="0.34" stopColor="#ECFAA0" />
                    {'\n'}
                    <stop offset="0.7" stopColor="#44E3EE" />
                    {'\n'}
                    <stop offset="1" stopColor="#CED7F8" />
                    {'\n'}
                  </linearGradient>
                  {'\n'}
                  <clipPath id="clip0_285_10884">
                    {'\n'}
                    <rect width="32" height="32" fill="white" />
                    {'\n'}
                  </clipPath>
                  {'\n'}
                </defs>
                {'\n'}
              </svg>
            </div>
            <div className="w-layout-vflex story-content">
              <div className="text-heading-h4">$8.5m+</div>
              <div className="text-body">Funding raised</div>
            </div>
          </div>
          <div className="story-highlight">
            <div className="w-embed">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                {'\n'}
                <g clipPath="url(#clip0_285_10815)">
                  {'\n'}
                  <path
                    d="M17.3333 2.66675L4 18.6667H16L14.6667 29.3334L28 13.3334H16L17.3333 2.66675Z"
                    stroke="url(#paint0_linear_285_10815)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  {'\n'}
                </g>
                {'\n'}
                <defs>
                  {'\n'}
                  <linearGradient
                    id="paint0_linear_285_10815"
                    x1="4.36426"
                    y1="18.9041"
                    x2="26.1889"
                    y2="11.3149"
                    gradientUnits="userSpaceOnUse"
                  >
                    {'\n'}
                    <stop offset="0.03" stopColor="#C8F62E" />
                    {'\n'}
                    <stop offset="0.34" stopColor="#ECFAA0" />
                    {'\n'}
                    <stop offset="0.7" stopColor="#44E3EE" />
                    {'\n'}
                    <stop offset="1" stopColor="#CED7F8" />
                    {'\n'}
                  </linearGradient>
                  {'\n'}
                  <clipPath id="clip0_285_10815">
                    {'\n'}
                    <rect width="32" height="32" fill="white" />
                    {'\n'}
                  </clipPath>
                  {'\n'}
                </defs>
                {'\n'}
              </svg>
            </div>
            <div className="w-layout-vflex story-content">
              <div className="text-heading-h4">3 years</div>
              <div className="text-body">{'MIT-Stanford R&D'}</div>
            </div>
          </div>
        </div>
      </section>
      <section className="card-investors">
        <div className="div-block-11">
          <h3 className="text-heading-h3">Our investors</h3>
          <div className="text-body">
            We’ve raised over $8.5m, trusted by leading venture capital firms across the globe.
          </div>
        </div>
        <div className="w-layout-hflex card-investors-images">
          <img
            src="/assets/images/672eb18de6278937936ac4db_The-Engine-Ventures.png"
            loading="lazy"
            alt="The Engine Ventures Logo"
            className="card-investors-image-item"
          />
          <img
            src="/assets/images/672eb18db723a27309f438f4_Construct.png"
            loading="lazy"
            alt="Construct Logo"
            className="card-investors-image-item"
          />
          <img
            src="/assets/images/672eb18d5f25ea9083ccd74c_Sinewave-Ventures.png"
            loading="lazy"
            alt="Sinewave Ventures Logo"
            className="card-investors-image-item"
          />
          <img
            src="/assets/images/672eb18db723a27309f438f0_Gutbrain-Ventures.png"
            loading="lazy"
            alt="Gutbrain Ventures Logo"
            className="card-investors-image-item"
          />
        </div>
      </section>
      <div className="card-team-wrapper">
        <h2 id="team" className="text-heading-h2">
          Leadership
        </h2>
        <div className="card-team-member-wrapper w-dyn-list">
          <div role="list" className="card-team-member-collection w-dyn-items w-row">
            <div role="listitem" className="card-team-member-item w-dyn-item w-col w-col-3">
              <img
                src="/assets/cms/672d9313f2a3c344e2e0436d_65ec05e8b3a939d61c07c620_qian-li-dbos.jpeg"
                loading="lazy"
                alt=""
                className="team-member-image"
              />
              <div className="team-member-bio">
                <div className="text-body-highlight team-member-body">Qian Li</div>
                <div className="text-body team-member-body">CEO, Co-founder</div>
              </div>
              <a href="https://www.linkedin.com/in/qianli-dev/" className="social-link-wrapper w-inline-block">
                <div className="social-link">
                  <div className="social-link-code w-embed">
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {'\n'}
                      <path
                        d="M0.5 1.61369C0.5 1.22889 0.635139 0.911425 0.905405 0.661313C1.17567 0.411189 1.52703 0.286133 1.95946 0.286133C2.38417 0.286133 2.7278 0.409261 2.99035 0.655541C3.26061 0.909509 3.39575 1.24043 3.39575 1.64833C3.39575 2.01773 3.26448 2.32557 3.00193 2.57185C2.73166 2.82581 2.37645 2.9528 1.93629 2.9528H1.92471C1.5 2.9528 1.15637 2.82581 0.893822 2.57185C0.63127 2.31788 0.5 1.99849 0.5 1.61369ZM0.650579 11.7147V4.0033H3.22201V11.7147H0.650579ZM4.64672 11.7147H7.21815V7.40878C7.21815 7.13942 7.24904 6.93162 7.31081 6.78541C7.41891 6.52374 7.58301 6.30248 7.80309 6.12163C8.02317 5.94077 8.29922 5.85034 8.63127 5.85034C9.49614 5.85034 9.92857 6.43139 9.92857 7.59349V11.7147H12.5V7.29334C12.5 6.15433 12.2297 5.29046 11.6892 4.70172C11.1486 4.11297 10.4344 3.8186 9.54633 3.8186C8.55019 3.8186 7.77413 4.24573 7.21815 5.09998V5.12307H7.20656L7.21815 5.09998V4.0033H4.64672C4.66216 4.24957 4.66988 5.01532 4.66988 6.30056C4.66988 7.58579 4.66216 9.3905 4.64672 11.7147Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </div>
              </a>
            </div>
            <div role="listitem" className="card-team-member-item w-dyn-item w-col w-col-3">
              <img
                src="/assets/cms/672d931372eb3a8fff51db11_65ec0883347d350eebbab02c_peter-kraft-website2.png"
                loading="lazy"
                alt=""
                className="team-member-image"
              />
              <div className="team-member-bio">
                <div className="text-body-highlight team-member-body">Peter Kraft</div>
                <div className="text-body team-member-body">CTO, Co-founder</div>
              </div>
              <a
                href="https://www.linkedin.com/in/peter-kraft-110318b0/"
                className="social-link-wrapper w-inline-block"
              >
                <div className="social-link">
                  <div className="social-link-code w-embed">
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {'\n'}
                      <path
                        d="M0.5 1.61369C0.5 1.22889 0.635139 0.911425 0.905405 0.661313C1.17567 0.411189 1.52703 0.286133 1.95946 0.286133C2.38417 0.286133 2.7278 0.409261 2.99035 0.655541C3.26061 0.909509 3.39575 1.24043 3.39575 1.64833C3.39575 2.01773 3.26448 2.32557 3.00193 2.57185C2.73166 2.82581 2.37645 2.9528 1.93629 2.9528H1.92471C1.5 2.9528 1.15637 2.82581 0.893822 2.57185C0.63127 2.31788 0.5 1.99849 0.5 1.61369ZM0.650579 11.7147V4.0033H3.22201V11.7147H0.650579ZM4.64672 11.7147H7.21815V7.40878C7.21815 7.13942 7.24904 6.93162 7.31081 6.78541C7.41891 6.52374 7.58301 6.30248 7.80309 6.12163C8.02317 5.94077 8.29922 5.85034 8.63127 5.85034C9.49614 5.85034 9.92857 6.43139 9.92857 7.59349V11.7147H12.5V7.29334C12.5 6.15433 12.2297 5.29046 11.6892 4.70172C11.1486 4.11297 10.4344 3.8186 9.54633 3.8186C8.55019 3.8186 7.77413 4.24573 7.21815 5.09998V5.12307H7.20656L7.21815 5.09998V4.0033H4.64672C4.66216 4.24957 4.66988 5.01532 4.66988 6.30056C4.66988 7.58579 4.66216 9.3905 4.64672 11.7147Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </div>
              </a>
            </div>
            <div role="listitem" className="card-team-member-item w-dyn-item w-col w-col-3">
              <img
                src="/assets/cms/672d9314e4f81e35c1768cc2_65ec091943fefe0808e37f5e_Stonebraker-quote.png"
                loading="lazy"
                alt=""
                className="team-member-image"
              />
              <div className="team-member-bio">
                <div className="text-body-highlight team-member-body">Mike Stonebraker</div>
                <div className="text-body team-member-body">Architect, Co-founder</div>
              </div>
              <a
                href="https://www.linkedin.com/in/michael-stonebraker-1064661a/"
                className="social-link-wrapper w-inline-block"
              >
                <div className="social-link">
                  <div className="social-link-code w-embed">
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {'\n'}
                      <path
                        d="M0.5 1.61369C0.5 1.22889 0.635139 0.911425 0.905405 0.661313C1.17567 0.411189 1.52703 0.286133 1.95946 0.286133C2.38417 0.286133 2.7278 0.409261 2.99035 0.655541C3.26061 0.909509 3.39575 1.24043 3.39575 1.64833C3.39575 2.01773 3.26448 2.32557 3.00193 2.57185C2.73166 2.82581 2.37645 2.9528 1.93629 2.9528H1.92471C1.5 2.9528 1.15637 2.82581 0.893822 2.57185C0.63127 2.31788 0.5 1.99849 0.5 1.61369ZM0.650579 11.7147V4.0033H3.22201V11.7147H0.650579ZM4.64672 11.7147H7.21815V7.40878C7.21815 7.13942 7.24904 6.93162 7.31081 6.78541C7.41891 6.52374 7.58301 6.30248 7.80309 6.12163C8.02317 5.94077 8.29922 5.85034 8.63127 5.85034C9.49614 5.85034 9.92857 6.43139 9.92857 7.59349V11.7147H12.5V7.29334C12.5 6.15433 12.2297 5.29046 11.6892 4.70172C11.1486 4.11297 10.4344 3.8186 9.54633 3.8186C8.55019 3.8186 7.77413 4.24573 7.21815 5.09998V5.12307H7.20656L7.21815 5.09998V4.0033H4.64672C4.66216 4.24957 4.66988 5.01532 4.66988 6.30056C4.66988 7.58579 4.66216 9.3905 4.64672 11.7147Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <h2 id="team" className="text-heading-h2">
          Advisors
        </h2>
        <div className="card-team-member-wrapper w-dyn-list">
          <div role="list" className="card-team-member-collection w-dyn-items">
            <div role="listitem" className="card-team-member-item w-dyn-item">
              <img
                src="/assets/cms/672d93127def01f8d3c19d81_65ed067f8a3ca1143142e9f6_Matei-website.png"
                loading="lazy"
                alt=""
                className="team-member-image"
              />
              <div className="team-member-bio">
                <div className="text-body-highlight team-member-body">Matei Zaharia</div>
                <div className="text-body team-member-body">Founding Advisor</div>
              </div>
              <a href="https://www.linkedin.com/in/mateizaharia/" className="social-link-wrapper w-inline-block">
                <div className="social-link">
                  <div className="social-link-code w-embed">
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {'\n'}
                      <path
                        d="M0.5 1.61369C0.5 1.22889 0.635139 0.911425 0.905405 0.661313C1.17567 0.411189 1.52703 0.286133 1.95946 0.286133C2.38417 0.286133 2.7278 0.409261 2.99035 0.655541C3.26061 0.909509 3.39575 1.24043 3.39575 1.64833C3.39575 2.01773 3.26448 2.32557 3.00193 2.57185C2.73166 2.82581 2.37645 2.9528 1.93629 2.9528H1.92471C1.5 2.9528 1.15637 2.82581 0.893822 2.57185C0.63127 2.31788 0.5 1.99849 0.5 1.61369ZM0.650579 11.7147V4.0033H3.22201V11.7147H0.650579ZM4.64672 11.7147H7.21815V7.40878C7.21815 7.13942 7.24904 6.93162 7.31081 6.78541C7.41891 6.52374 7.58301 6.30248 7.80309 6.12163C8.02317 5.94077 8.29922 5.85034 8.63127 5.85034C9.49614 5.85034 9.92857 6.43139 9.92857 7.59349V11.7147H12.5V7.29334C12.5 6.15433 12.2297 5.29046 11.6892 4.70172C11.1486 4.11297 10.4344 3.8186 9.54633 3.8186C8.55019 3.8186 7.77413 4.24573 7.21815 5.09998V5.12307H7.20656L7.21815 5.09998V4.0033H4.64672C4.66216 4.24957 4.66988 5.01532 4.66988 6.30056C4.66988 7.58579 4.66216 9.3905 4.64672 11.7147Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </div>
              </a>
            </div>
            <div role="listitem" className="card-team-member-item w-dyn-item">
              <img
                src="/assets/cms/672d9311b7744ac239e6b17a_65efec50a4fbb3b13015d90b_Christos-Kozyrakis.png"
                loading="lazy"
                alt=""
                className="team-member-image"
              />
              <div className="team-member-bio">
                <div className="text-body-highlight team-member-body">Christos Kozyrakis</div>
                <div className="text-body team-member-body">Founding Advisor</div>
              </div>
              <a href="https://www.linkedin.com/in/ckozyrakis/" className="social-link-wrapper w-inline-block">
                <div className="social-link">
                  <div className="social-link-code w-embed">
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {'\n'}
                      <path
                        d="M0.5 1.61369C0.5 1.22889 0.635139 0.911425 0.905405 0.661313C1.17567 0.411189 1.52703 0.286133 1.95946 0.286133C2.38417 0.286133 2.7278 0.409261 2.99035 0.655541C3.26061 0.909509 3.39575 1.24043 3.39575 1.64833C3.39575 2.01773 3.26448 2.32557 3.00193 2.57185C2.73166 2.82581 2.37645 2.9528 1.93629 2.9528H1.92471C1.5 2.9528 1.15637 2.82581 0.893822 2.57185C0.63127 2.31788 0.5 1.99849 0.5 1.61369ZM0.650579 11.7147V4.0033H3.22201V11.7147H0.650579ZM4.64672 11.7147H7.21815V7.40878C7.21815 7.13942 7.24904 6.93162 7.31081 6.78541C7.41891 6.52374 7.58301 6.30248 7.80309 6.12163C8.02317 5.94077 8.29922 5.85034 8.63127 5.85034C9.49614 5.85034 9.92857 6.43139 9.92857 7.59349V11.7147H12.5V7.29334C12.5 6.15433 12.2297 5.29046 11.6892 4.70172C11.1486 4.11297 10.4344 3.8186 9.54633 3.8186C8.55019 3.8186 7.77413 4.24573 7.21815 5.09998V5.12307H7.20656L7.21815 5.09998V4.0033H4.64672C4.66216 4.24957 4.66988 5.01532 4.66988 6.30056C4.66988 7.58579 4.66216 9.3905 4.64672 11.7147Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </div>
              </a>
            </div>
            <div role="listitem" className="card-team-member-item w-dyn-item">
              <img
                src="/assets/cms/672d93140e42bf55d213d8b1_65efeadefd08eb1a80897671_Andy-Palmer-2.png"
                loading="lazy"
                alt=""
                className="team-member-image"
              />
              <div className="team-member-bio">
                <div className="text-body-highlight team-member-body">Andy Palmer</div>
                <div className="text-body team-member-body">Chairman, Co-founder</div>
              </div>
              <a href="https://www.linkedin.com/in/andypalmer/" className="social-link-wrapper w-inline-block">
                <div className="social-link">
                  <div className="social-link-code w-embed">
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {'\n'}
                      <path
                        d="M0.5 1.61369C0.5 1.22889 0.635139 0.911425 0.905405 0.661313C1.17567 0.411189 1.52703 0.286133 1.95946 0.286133C2.38417 0.286133 2.7278 0.409261 2.99035 0.655541C3.26061 0.909509 3.39575 1.24043 3.39575 1.64833C3.39575 2.01773 3.26448 2.32557 3.00193 2.57185C2.73166 2.82581 2.37645 2.9528 1.93629 2.9528H1.92471C1.5 2.9528 1.15637 2.82581 0.893822 2.57185C0.63127 2.31788 0.5 1.99849 0.5 1.61369ZM0.650579 11.7147V4.0033H3.22201V11.7147H0.650579ZM4.64672 11.7147H7.21815V7.40878C7.21815 7.13942 7.24904 6.93162 7.31081 6.78541C7.41891 6.52374 7.58301 6.30248 7.80309 6.12163C8.02317 5.94077 8.29922 5.85034 8.63127 5.85034C9.49614 5.85034 9.92857 6.43139 9.92857 7.59349V11.7147H12.5V7.29334C12.5 6.15433 12.2297 5.29046 11.6892 4.70172C11.1486 4.11297 10.4344 3.8186 9.54633 3.8186C8.55019 3.8186 7.77413 4.24573 7.21815 5.09998V5.12307H7.20656L7.21815 5.09998V4.0033H4.64672C4.66216 4.24957 4.66988 5.01532 4.66988 6.30056C4.66988 7.58579 4.66216 9.3905 4.64672 11.7147Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </div>
              </a>
            </div>
            <div role="listitem" className="card-team-member-item w-dyn-item">
              <img
                src="/assets/cms/672d9311fd053144906eae6e_66bade85c6a0c383636c20ee_Jeremy-Edberg-2.png"
                loading="lazy"
                alt=""
                className="team-member-image"
              />
              <div className="team-member-bio">
                <div className="text-body-highlight team-member-body">Jeremy Edberg</div>
                <div className="text-body team-member-body">Advisor</div>
              </div>
              <a href="https://www.linkedin.com/in/jedberg/" className="social-link-wrapper w-inline-block">
                <div className="social-link">
                  <div className="social-link-code w-embed">
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {'\n'}
                      <path
                        d="M0.5 1.61369C0.5 1.22889 0.635139 0.911425 0.905405 0.661313C1.17567 0.411189 1.52703 0.286133 1.95946 0.286133C2.38417 0.286133 2.7278 0.409261 2.99035 0.655541C3.26061 0.909509 3.39575 1.24043 3.39575 1.64833C3.39575 2.01773 3.26448 2.32557 3.00193 2.57185C2.73166 2.82581 2.37645 2.9528 1.93629 2.9528H1.92471C1.5 2.9528 1.15637 2.82581 0.893822 2.57185C0.63127 2.31788 0.5 1.99849 0.5 1.61369ZM0.650579 11.7147V4.0033H3.22201V11.7147H0.650579ZM4.64672 11.7147H7.21815V7.40878C7.21815 7.13942 7.24904 6.93162 7.31081 6.78541C7.41891 6.52374 7.58301 6.30248 7.80309 6.12163C8.02317 5.94077 8.29922 5.85034 8.63127 5.85034C9.49614 5.85034 9.92857 6.43139 9.92857 7.59349V11.7147H12.5V7.29334C12.5 6.15433 12.2297 5.29046 11.6892 4.70172C11.1486 4.11297 10.4344 3.8186 9.54633 3.8186C8.55019 3.8186 7.77413 4.24573 7.21815 5.09998V5.12307H7.20656L7.21815 5.09998V4.0033H4.64672C4.66216 4.24957 4.66988 5.01532 4.66988 6.30056C4.66988 7.58579 4.66216 9.3905 4.64672 11.7147Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </div>
              </a>
            </div>
            <div role="listitem" className="card-team-member-item w-dyn-item">
              <img
                src="/assets/cms/672d931150ba8adb3e13a378_66dfc3cda915f6282bc3b016_Heather-Ritchie-DBOS.jpeg"
                loading="lazy"
                alt=""
                className="team-member-image"
              />
              <div className="team-member-bio">
                <div className="text-body-highlight team-member-body">Heather Ritchie</div>
                <div className="text-body team-member-body">Advisor</div>
              </div>
              <a href="https://www.linkedin.com/in/heatheranneritchie/" className="social-link-wrapper w-inline-block">
                <div className="social-link">
                  <div className="social-link-code w-embed">
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {'\n'}
                      <path
                        d="M0.5 1.61369C0.5 1.22889 0.635139 0.911425 0.905405 0.661313C1.17567 0.411189 1.52703 0.286133 1.95946 0.286133C2.38417 0.286133 2.7278 0.409261 2.99035 0.655541C3.26061 0.909509 3.39575 1.24043 3.39575 1.64833C3.39575 2.01773 3.26448 2.32557 3.00193 2.57185C2.73166 2.82581 2.37645 2.9528 1.93629 2.9528H1.92471C1.5 2.9528 1.15637 2.82581 0.893822 2.57185C0.63127 2.31788 0.5 1.99849 0.5 1.61369ZM0.650579 11.7147V4.0033H3.22201V11.7147H0.650579ZM4.64672 11.7147H7.21815V7.40878C7.21815 7.13942 7.24904 6.93162 7.31081 6.78541C7.41891 6.52374 7.58301 6.30248 7.80309 6.12163C8.02317 5.94077 8.29922 5.85034 8.63127 5.85034C9.49614 5.85034 9.92857 6.43139 9.92857 7.59349V11.7147H12.5V7.29334C12.5 6.15433 12.2297 5.29046 11.6892 4.70172C11.1486 4.11297 10.4344 3.8186 9.54633 3.8186C8.55019 3.8186 7.77413 4.24573 7.21815 5.09998V5.12307H7.20656L7.21815 5.09998V4.0033H4.64672C4.66216 4.24957 4.66988 5.01532 4.66988 6.30056C4.66988 7.58579 4.66216 9.3905 4.64672 11.7147Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}
